import React from 'react';
import { LegacyAuditsSection } from '../../../../components/legacyAudits';
import type { Store as StoreType } from '../../../../services/authService';
import type { StoreAuditReportsResponse } from '../../../../services/storeAuditReportsService';

type StoreDetailsAuditsTabProps = {
    store: StoreType | null;
    auditReports: StoreAuditReportsResponse | null;
    auditReportsLoading: boolean;
    auditReportsError: string;
    onRefresh: () => void;
    dateRangeLabel: string;
    auditDateRange: [Date | null, Date | null];
    setAuditDateRange: (range: [Date | null, Date | null]) => void;
};

const StoreDetailsAuditsTab: React.FC<StoreDetailsAuditsTabProps> = (props) => (
    <LegacyAuditsSection {...props} />
);

export default React.memo(StoreDetailsAuditsTab);
